var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hide)?_c('div',{on:{"click":_vm.hideHandler}},[_vm._v("\n    "+_vm._s(_vm.hideText)+" "),_c('a-icon',{staticClass:"hide-icon",attrs:{"type":"eye"}})],1):_c('div',[_vm._v("\n    "+_vm._s(_vm.text)+" \n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }